/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightBagOption } from "./FlightBagOption";
import {
  FlightBagOptionFromJSON,
  FlightBagOptionFromJSONTyped,
  FlightBagOptionToJSON,
  FlightBagOptionToJSONTyped,
} from "./FlightBagOption";

/**
 *
 * @export
 * @interface FlightBagsResponse
 */
export interface FlightBagsResponse {
  /**
   *
   * @type {boolean}
   * @memberof FlightBagsResponse
   */
  test: boolean;
  /**
   *
   * @type {string}
   * @memberof FlightBagsResponse
   */
  provider: string;
  /**
   *
   * @type {string}
   * @memberof FlightBagsResponse
   */
  handoffId: string;
  /**
   *
   * @type {string}
   * @memberof FlightBagsResponse
   */
  quoteId: string;
  /**
   *
   * @type {string}
   * @memberof FlightBagsResponse
   */
  status: FlightBagsResponseStatusEnum;
  /**
   *
   * @type {Array<FlightBagOption>}
   * @memberof FlightBagsResponse
   */
  options: Array<FlightBagOption>;
}

/**
 * @export
 */
export const FlightBagsResponseStatusEnum = {
  Available: "available",
  Unavailable: "unavailable",
} as const;
export type FlightBagsResponseStatusEnum =
  (typeof FlightBagsResponseStatusEnum)[keyof typeof FlightBagsResponseStatusEnum];

/**
 * Check if a given object implements the FlightBagsResponse interface.
 */
export function instanceOfFlightBagsResponse(
  value: object
): value is FlightBagsResponse {
  if (!("test" in value) || value["test"] === undefined) return false;
  if (!("provider" in value) || value["provider"] === undefined) return false;
  if (!("handoffId" in value) || value["handoffId"] === undefined) return false;
  if (!("quoteId" in value) || value["quoteId"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("options" in value) || value["options"] === undefined) return false;
  return true;
}

export function FlightBagsResponseFromJSON(json: any): FlightBagsResponse {
  return FlightBagsResponseFromJSONTyped(json, false);
}

export function FlightBagsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBagsResponse {
  if (json == null) {
    return json;
  }
  return {
    test: json["test"],
    provider: json["provider"],
    handoffId: json["handoff_id"],
    quoteId: json["quote_id"],
    status: json["status"],
    options: (json["options"] as Array<any>).map(FlightBagOptionFromJSON),
  };
}

export function FlightBagsResponseToJSON(json: any): FlightBagsResponse {
  return FlightBagsResponseToJSONTyped(json, false);
}

export function FlightBagsResponseToJSONTyped(
  value?: FlightBagsResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    test: value["test"],
    provider: value["provider"],
    handoff_id: value["handoffId"],
    quote_id: value["quoteId"],
    status: value["status"],
    options: (value["options"] as Array<any>).map(FlightBagOptionToJSON),
  };
}
